import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-109e0fe6")

_pushScopeId("data-v-109e0fe6")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Edit the delivery address")
const _hoisted_2 = { class: "px-16" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_FInput = _resolveComponent("FInput")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Form = _resolveComponent("Form")
  const _component_Holder = _resolveComponent("Holder")
  const _component_Button = _resolveComponent("Button")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, { class: "fill-up bg-white" }, {
    title: _withId(() => [
      _createVNode(_component_t, { path: "xmasaddress_2" }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    footer: _withId(() => [
      _createVNode(_component_Button, {
        class: "block primary f-lg f-bold",
        onClick: _ctx.submit,
        progress: _ctx.progress
      }, {
        default: _withId(() => [
          _createVNode(_component_t, {
            path: "xmasaddress_9",
            custom: ""
          }, {
            default: _withId(({td}) => [
              _createTextVNode(_toDisplayString(td || 'Submit'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick", "progress"])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_t, { custom: "" }, {
          default: _withId(({td, t}) => [
            _createVNode(_component_Holder, {
              content: _ctx.loaded,
              "skeleton-repeat": 2,
              "holder-class": "px-12"
            }, {
              default: _withId(() => [
                (_ctx.loaded)
                  ? (_openBlock(), _createBlock(_component_Form, {
                      key: 0,
                      ref: "form",
                      schema: _ctx.schema,
                      onSubmit: _ctx.bind,
                      class: "my-16"
                    }, {
                      default: _withId(({ values }) => [
                        _createVNode(_component_FInput, {
                          name: "recipientName",
                          placeholder: t('xmasaddress_3') || `Recipient's name`,
                          class: "block"
                        }, null, 8, ["placeholder"]),
                        _createVNode(_component_FInput, {
                          name: "recipientMobile",
                          placeholder: t('xmasaddress_4') || `Phone number`,
                          class: "block"
                        }, null, 8, ["placeholder"]),
                        _createVNode(_component_FInput, {
                          name: "recipientCity",
                          placeholder: t('xmasaddress_5') || `City`,
                          class: "block"
                        }, null, 8, ["placeholder"]),
                        _createVNode(_component_FInput, {
                          name: "recipientProvince",
                          placeholder: t('xmasaddress_6') || `State / Province / Oblast`,
                          class: "block"
                        }, null, 8, ["placeholder"]),
                        _createVNode(_component_FInput, {
                          name: "recipientZipCode",
                          placeholder: t('xmasaddress_7') || `Zip Code / Post Cade`,
                          class: "block"
                        }, null, 8, ["placeholder"]),
                        _createVNode(_component_Textarea, {
                          name: "recipientAddress",
                          placeholder: t('xmasaddress_8') || 'Detailed  Address',
                          rows: "4",
                          class: "mt-12 block p-8"
                        }, null, 8, ["placeholder"])
                      ]),
                      _: 2
                    }, 1032, ["schema", "onSubmit"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["content"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
})